export enum UInspectQuestionTypeEnum {
  Option = 1,
  Number,
  Date,
  Bool,
  String
}
